<span [ngClass]="size" class="text-primary  cursor-pointer sm:mb-1 font-bold">
  <fa-icon class="" [icon]="recommend ? icons.faHeart : icons.faHeartRegular" class="mr-2"></fa-icon>{{recommend ? "Tích cực" : "Không tích cực"}}
</span>